// Payment gateway logo components with official brand colors
// These are text-based logo representations for consistent display

export function BillplzLogo({ className = '' }) {
  return (
    <svg viewBox="0 0 120 40" className={className} xmlns="http://www.w3.org/2000/svg">
      <rect width="120" height="40" rx="4" fill="#0F50FF" />
      <text x="60" y="26" textAnchor="middle" fill="white" fontFamily="Arial, sans-serif" fontWeight="900" fontSize="16" letterSpacing="1.5">
        BILLPLZ
      </text>
    </svg>
  );
}

export function ToyyibPayLogo({ className = '' }) {
  return (
    <svg viewBox="0 0 120 40" className={className} xmlns="http://www.w3.org/2000/svg">
      <rect width="120" height="40" rx="4" fill="#00B74F" />
      <text x="60" y="26" textAnchor="middle" fill="white" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="14">
        toyyibPay
      </text>
    </svg>
  );
}

export function SenangPayLogo({ className = '' }) {
  return (
    <svg viewBox="0 0 120 40" className={className} xmlns="http://www.w3.org/2000/svg">
      <rect width="120" height="40" rx="4" fill="white" stroke="#E5E7EB" strokeWidth="1" />
      <text x="14" y="27" fill="#FF6B35" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="14">
        senang
      </text>
      <text x="76" y="27" fill="#333333" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="14">
        Pay
      </text>
    </svg>
  );
}

export function StripeLogo({ className = '' }) {
  return (
    <svg viewBox="0 0 120 40" className={className} xmlns="http://www.w3.org/2000/svg">
      <rect width="120" height="40" rx="4" fill="#635BFF" />
      <text x="60" y="27" textAnchor="middle" fill="white" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="18" letterSpacing="0.5">
        stripe
      </text>
    </svg>
  );
}

export function RevenueMonsterLogo({ className = '' }) {
  return (
    <svg viewBox="0 0 120 40" className={className} xmlns="http://www.w3.org/2000/svg">
      <rect width="120" height="40" rx="4" fill="#1A1A2E" />
      <text x="60" y="21" textAnchor="middle" fill="#E94560" fontFamily="Arial, sans-serif" fontWeight="800" fontSize="11">
        REVENUE
      </text>
      <text x="60" y="33" textAnchor="middle" fill="white" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="10">
        MONSTER
      </text>
    </svg>
  );
}
